module.exports = __webpack_public_path__ + "img/max-cloud-deny.073c0367.svg";